"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CSSTransition = exports.triggerBrowserReflow = exports.transitionClassNames = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _reactTransitionGroup = require("react-transition-group");

var transitionClassNames = function transitionClassNames(block) {
  return {
    appear: "".concat(block, "--appear"),
    appearActive: "".concat(block, "--appearing"),
    enter: "".concat(block, "--enter"),
    enterActive: "".concat(block, "--entering"),
    exit: "".concat(block, "--exit"),
    exitActive: "".concat(block, "--exiting")
  };
};

exports.transitionClassNames = transitionClassNames;

var triggerBrowserReflow = function triggerBrowserReflow($$node) {
  $$node.offsetHeight;
};

exports.triggerBrowserReflow = triggerBrowserReflow;

var CSSTransition = function CSSTransition(_ref) {
  var block = _ref.block,
      otherProps = (0, _objectWithoutProperties2.default)(_ref, ["block"]);
  return React.createElement(_reactTransitionGroup.CSSTransition, Object.assign({
    classNames: transitionClassNames(block)
  }, otherProps));
};

exports.CSSTransition = CSSTransition;